import React from "react";
const mesageTemplate = [
    { heading: [{ key: 'Status', value: 'status' }], style: {marginTop:'14.5px'} },
    { heading: [{ key: 'Date Created', value: 'dateCreated' }, { key: 'Author', value: 'author' }], style: {} },
    { heading: [{ key: 'Account Name', value: 'accountName' }], style: { width: '100%', marginRight: '0px' } },
    { heading: [{ key: 'Render to', value: 'renderTo' }, { key: 'Render style', value: 'notificationStyle' }], style: {} },
    { heading: [{ key: 'Publish date', value: 'publishedOn' }, { key: 'Expiry date', value: 'expiredOn' }], style: {} },
    { heading: [{ key: 'Message', value: 'message' }], style: { width: '100%', marginRight: '0px',height:'100px' ,alignItems:'flex-start',paddingTop:'7px',overflowY:'scroll'} },
]
const MessageInformation = (props) => {
    let selectedMessage = props.selectedMessage
    return (
        <div style={{ color: 'black' }}>
            <div className="mg-messanger-header">
                <span className="mg-messanger-h1">Message Information</span>
                <span className="mg-messanger-h1-close" onClick={props.goBack}><i className="fa fa-arrow-left" aria-hidden="true"></i></span>
            </div>
            <div style={{ border: '1px solid rgba(151,151,151,0.26)', marginTop: '-5.5px' }}></div>
            {/* <div className="mg-messanger-subContent mg-messanger-info">
                <div>Status</div>
            </div> */}
            {
                mesageTemplate.map((obj) => {
                    let i = obj.heading.length === 2 ? 1 : 0
                    return (
                        <div>
                            <div className="mg-messanger-flex mg-message-config-flex" >
                                <div className={`mg-messageConfig mg-messanger-info-mr ${obj.heading[0].key==='Status' && 'mg-messanger-info'}`}
                                style={{marginRight:'7%'}}>{obj.heading[0].key}</div>
                                {obj.heading.length === 2 ?
                                    <div className="mg-messageConfig" >{obj.heading[i].key}</div>
                                    : <div className="mg-messageConfig mg-messanger-info-boxHide"></div>
                                }
                            </div>
                            <div className="mg-messanger-flex mg-message-config-flex" >
                                <div className="mg-messanger-info-box mg-messanger-info-mr" style={obj.style}>
                                    <div className={`mg-text ${ obj.heading[0].value==='accountName' && ' accountNameList'} `}>
                                        {selectedMessage[obj.heading[0].value]}</div>
                                </div>
                                {obj.heading.length === 2 &&
                                    <div className="mg-messanger-info-box">
                                        <div className="mg-text">{selectedMessage[obj.heading[i].value]}</div>
                                    </div>

                                }

                            </div>
                        </div>
                    )
                })
            }

        </div>
    )

}

export default MessageInformation;


/** WEBPACK FOOTER **
 ** ./src/components/MyGameMessanger2/MessageInformation.js
 **/